import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import img from './img.png';

function GiftHeader() {
    const { t } = useTranslation('gift');
    return (
        <Container align='center' fullWidth
            spacing={32}>
            <HeaderImage src={img}
                width={224}
                alt='' />
            <Text size='3xl' fontWeight='bold'>
                {t('giftReceived.headerMessage', { name: '김찡찡' })}
            </Text>
        </Container>
    );
}

const Container = styled(Column)`
    padding-top: 48px;
`;

const HeaderImage = styled(Image)`
    transform: translateX(6%);
`;

export default GiftHeader;
